import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Badge } from '../components';

interface ChipsProps {
  text: string;
  icon: IconDefinition;
  totalTypeSelected?: string;
  showClose: boolean;
  highlight: boolean;
  onClick?: () => void;
  onCloseClick?: () => void;
  isSelected?: boolean;
}

export const Chips: React.FC<ChipsProps> = ({
  text,
  icon,
  totalTypeSelected,
  showClose,
  highlight,
  onClick,
  onCloseClick,
  isSelected,
}) => {
  const [highlighted, setHighlighted] = useState<any>(isSelected);

  const handleChipClick = () => {
    if (onClick) {
      onClick();
    }

    if (highlight) {
      setHighlighted((isSelect: any) => !isSelect);
    }
  };

  useEffect(() => {
    // console.log('highlighted', highlighted)
  }, [highlighted]);

  const showTypeSelected = (total: any) => {
    if (total && total > 0 && total !== 0) {
      return true;
    }
    return false;
  };

  return (
    <View style={styles.chipContainer}>
      <TouchableOpacity onPress={handleChipClick}>
        <View style={[styles.chip, isSelected && styles.highlightedChip]}>
          {!showClose && <FontAwesomeIcon icon={icon} size={'xs'} />}
          <Text style={[styles.chipText, isSelected ? styles.highlightedText : styles.chipText]}>{text}</Text>
          {showClose && (
            <FontAwesomeIcon icon={faTimes} size={'xs'} onClick={onCloseClick} style={styles.chipCloseIcon} />
          )}
          {totalTypeSelected && showTypeSelected(totalTypeSelected) && (
            <Badge
              value={totalTypeSelected.toString()}
              containerStyle={{ marginStart: 15, marginEnd: 10 }}
              backgroundColor="#8e00ff"
              textColor="#fff"
              children={null}
            />
          )}
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  chipContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: '#000',
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  highlightedChip: {
    backgroundColor: '#8e00ff', // Purple color for highlighting
  },
  chipText: {
    marginLeft: 8,
    fontWeight: 'bold',
    color: 'black',
  },
  highlightedText: {
    color: '#fff', // White text color for highlighting
  },
  chipTypeIcon: {
    color: '#8e00ff',
  },
  highlightedIcon: {
    color: '#fff', // White icon color for highlighting
  },
  chipCloseIcon: {
    marginLeft: 10,
    fontWeight: 'bold',
    color: 'black',
  },
  highlightedCloseIcon: {
    color: '#fff', // White close icon color for highlighting
  },
  clickedChip: {
    backgroundColor: '#00ff00', // Green color when clicked again
  },
  clickedCloseIcon: {
    color: '#ff0000', // Red close icon color when clicked again
  },
  clickedText: {
    color: '#0000ff', // Blue text color when clicked again
  },
  selectedTypeText: {
    marginRight: 5,
    fontWeight: 'bold',
    color: 'black',
    backgroundColor: '#ff0000', // Set the background color for the chipCloseIcon
    borderRadius: 20,
  },
});

export default Chips;
